module.exports = __webpack_public_path__ + "static/media/dancers-purple.820b4296.png";